import React from 'react';
import { type FieldValues, type Path, useController, type UseControllerProps } from 'react-hook-form';

import { TextInputField } from '#/shared/components/FormField';

type TextInputProps = Omit<
  React.ComponentProps<typeof TextInputField>,
  'ref' | 'disabled' | 'required' | 'value' | 'defaultValue' | 'onChange' | 'onBlur'
>;

type FormControlTextInputProps<TFieldValues extends FieldValues, TName extends Path<TFieldValues>> = UseControllerProps<
  TFieldValues,
  TName
>;

export function FormControlTextInput<TFieldValues extends FieldValues, TName extends Path<TFieldValues>>({
  name,
  control,
  rules,
  defaultValue,
  disabled,
  ...props
}: FormControlTextInputProps<TFieldValues, TName> & TextInputProps) {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
    defaultValue,
    disabled,
  });
  return <TextInputField {...props} {...field} errorMessage={fieldState.error?.message} />;
}
